import * as React from 'react';
import { debounce } from '@comeon/utility';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

const allowTouchMove = targetElement => {
	let currentElement = targetElement;

	while (currentElement && currentElement !== document.body) {
		if (currentElement.getAttribute('data-body-scroll-lock-ignore') !== false) {
			return true;
		}

		currentElement = currentElement.parentElement;
	}
};

function hocDisableBodyScroll(Component) {
	class DisableBodyScroll extends React.Component {
		lockOrUnlock = debounce(
			value => {
				if (!this.props.forwardedRef) return;

				if (value) {
					if (!this._isLocked) {
						this._isLocked = true;

						disableBodyScroll(this.props.forwardedRef.current, {
							allowTouchMove
						});
					}
				} else if (this._isLocked) {
					this._isLocked = false;
					enableBodyScroll(this.props.forwardedRef.current);
				}
			},
			300,
			{ trailing: true }
		);

		constructor(props) {
			super(props);
			this._isLocked = false;
		}

		componentDidMount() {
			if (this.props.forceLock) {
				this.lock();
			} else if (this.props.lockOnHover) {
				this.set();
			}
		}

		componentDidUpdate(prevProps) {
			if (prevProps.forceLock !== this.props.forceLock) {
				if (this.props.forceLock) {
					this.lock();
				} else {
					this.unlock();
				}
			}

			if (!this.props.forceLock && prevProps.lockOnHover !== this.props.lockOnHover) {
				if (this.props.lockOnHover) {
					this.set();
				} else {
					this.reset();
				}
			}
		}

		componentWillUnmount() {
			this.reset();
			clearAllBodyScrollLocks();
		}

		set = () => {
			if (this.props.forwardedRef.current) {
				this.props.forwardedRef.current.onmouseenter = this.lock;
				this.props.forwardedRef.current.onmouseleave = this.unlock;
				this.props.forwardedRef.current.ontouchend = this.unlock;
			}
		};

		reset = () => {
			this.unlock();

			if (this.props.forwardedRef?.current) {
				this.props.forwardedRef.current.onmouseenter = null;
				this.props.forwardedRef.current.onmouseleave = null;
				this.props.forwardedRef.current.ontouchend = null;
			}
		};

		lock = () => {
			this.lockOrUnlock(true);
		};

		unlock = () => {
			this.lockOrUnlock(false);
		};

		render() {
			const { forwardedRef, ...rest } = this.props;

			return <Component ref={forwardedRef} {...rest} />;
		}
	}

	return React.forwardRef((props, ref) => <DisableBodyScroll {...props} forwardedRef={ref} />);
}

export default hocDisableBodyScroll;
